/* import __COLOCATED_TEMPLATE__ from './error-panel.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type Intl from 'ember-intl/services/intl';
import type CircuitService from '../services/circuit';

interface ErrorPanelSignature {
  Args: {
    openDialog: (text: string) => void;
  };
  Element: HTMLDivElement;
}
/**
 * A panel for displaying errors
 *
 * @extends {Component<ErrorPanelSignature>}
 */
export default class ErrorPanel extends Component<ErrorPanelSignature> {
  @service declare intl: Intl;
  @service declare circuit: CircuitService;

  get hasErrorMessages() {
    return this.errorMessages.length > 0;
  }
  get errorMessages() {
    let result = [];
    result.push(this.targetFrequencyApprochingNyquistMessage.shortMessage);
    result.push(this.isZoomingRequired.shortMessage);
    result.push(this.isAttenuatedFundamental.shortMessage);
    result = result.filter(function (item) {
      return item != '';
    });
    return result;
  }
  get errorDialogMessages() {
    let result = [];
    result.push(this.targetFrequencyApprochingNyquistMessage.longMessage);
    result.push(this.isZoomingRequired.longMessage);
    result.push(this.isAttenuatedFundamental.longMessage);
    result = result.filter(function (item) {
      return item != '';
    });
    return result;
  }
  get targetFrequencyApprochingNyquistMessage() {
    const result = { shortMessage: '', longMessage: '' };

    if (this.circuit.isTargetFreqApprochingNyquistFreq) {
      result.shortMessage = this.intl.t('errors.warning_nyquist_short');
      result.longMessage = this.intl.t('errors.warning_nyquist_long');
    }

    return result;
  }
  get isZoomingRequired() {
    const result = { shortMessage: '', longMessage: '' };
    if (this.circuit.isZoomingRequired) {
      result.shortMessage = this.intl.t('errors.warning_zooming_required_short');
      result.longMessage = this.intl.t('errors.warning_zooming_required_long');
    }

    return result;
  }
  get isAttenuatedFundamental() {
    const result = { shortMessage: '', longMessage: '' };

    if (this.circuit.isAttenuatedFundamental) {
      result.shortMessage = this.intl.t('errors.warning_attenuated_fundamental_short');
      result.longMessage = this.intl.t('errors.warning_attenuated_fundamental_long');
    }

    return result;
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ErrorPanel: typeof ErrorPanel;
  }
}
